// Vuex
import Request from './request';
import consts from "@/consts.js";

async function fetch(data) {
  if (!data) data = {};
  return Request('get', "api/distribution-centers/index", 
    Object.assign({},data,{
      itemsPerPage: consts.limitAll,
      limit: consts.limitAll,
    })
  );
}


export default {
    fetch
};